function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.848 17.034a.507.507 0 00-.002-.717l-5.995-6.01a.525.525 0 00-.74 0l-6 6.013a.507.507 0 00-.003.714l.715.731c.203.208.54.21.745.004l3.893-3.907v10.824c0 .283.232.512.52.512h1c.287 0 .52-.229.52-.512V13.862l3.874 3.908c.204.205.54.205.743 0l.73-.736z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.597 8.306a4.407 4.407 0 016.262 0l1.585 1.598 1.585-1.598a4.406 4.406 0 016.261 0l2.308 2.327-1.486 1.431-2.308-2.327a2.307 2.307 0 00-3.289 0l-3.07 3.098-3.072-3.098a2.308 2.308 0 00-3.29 0L2.772 12.07a2.42 2.42 0 000 3.39l4.105 4.142 4.128 4.164a.614.614 0 00.88 0l4.55-4.594.66-.666a.5.5 0 01.702-.008l.766.737a.5.5 0 01.008.713l-5.028 5.076-.16.161-.006.007-.006.006a2.713 2.713 0 01-3.852 0l-.008-.008-8.225-8.297a4.448 4.448 0 010-6.254l2.312-2.333z",
  fill: "currentColor"
})));